export const CUSTOMER_DETAILS_API_URL = 'pointsandrewardhome/widget/getCustomer/';
export const REDEEM_REWARDS_API_URL = 'pointsandrewardhome/widget/redeemReward/';
export const UPDATE_BIRTHDAY_API_URL = 'pointsandrewardhome/widget/changeCustomerBirthday/';
export const FAQ_API_URL = 'pointsandrewardhome/widget/getFaqs/';
export const UPDATE_POINTS_ON_SITE_VISIT =
  'pointsandrewardhome/widget/updatePointsByVisitingWebsite/';
export const WIDGET_SETTINGS_API_URL = 'pointsandrewardhome/widget/getWidgetSettings';